export default {
  HIOPOSWEBSERVICES: 'https://hiopos-dev.saas.com.co',
  HIOPOSREPORTS: 'https://hioposreports-dev.saas.com.co',
}
